export default {
  agentAvatar: 'Agent Avatar',
};
